import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface WorkspaceState {
  activeWorkspaceId: string | null
  activeOrgId: string | null
  /**
   * Display name of the active workspace, published by the sidebar switcher
   * (which already has the list). Kept here so workspace-scoped empty states
   * can name the workspace without every page taking a data dependency on
   * useWorkspaces/useOrgId.
   */
  activeWorkspaceName: string | null
  setActiveWorkspace: (workspaceId: string | null) => void
  setActiveWorkspaceName: (name: string | null) => void
  setActiveOrg: (orgId: string | null) => void
  reset: () => void
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeWorkspaceId: null,
      activeOrgId: null,
      activeWorkspaceName: null,
      // Clear the cached name alongside the id — a stale name on a new
      // workspace is worse than none.
      setActiveWorkspace: (activeWorkspaceId) =>
        set({ activeWorkspaceId, activeWorkspaceName: null }),
      setActiveWorkspaceName: (activeWorkspaceName) => set({ activeWorkspaceName }),
      setActiveOrg: (activeOrgId) => set({ activeOrgId }),
      reset: () =>
        set({ activeWorkspaceId: null, activeOrgId: null, activeWorkspaceName: null }),
    }),
    { name: 'qyngent-workspace' },
  ),
)
